import type { RootStore } from "../../store/RootStore";
import type { SimulationControlStore } from "./SimulationControlStore";

/** Eventos SSE específicos de simulación (NO pisar los globales de workflow/pipeline). */
const SIM_EVENT_TYPES = [
  "simulation.waiting",
  "simulation.advanced",
  "simulation.failed",
  "simulation.completed",
  "simulation.aborted",
];

/**
 * Registra handlers SSE para los eventos `simulation.*` que ruteen al store del
 * panel. Devuelve la función de cleanup (desregistra) para el unmount.
 */
export function registerSimulationSSEHandlers(
  rootStore: RootStore,
  store: SimulationControlStore
): () => void {
  for (const type of SIM_EVENT_TYPES) {
    rootStore.eventSourceStore.registerHandler(type, (payload: any) =>
      store.onSimEvent(type, payload)
    );
  }
  return () => {
    for (const type of SIM_EVENT_TYPES) rootStore.eventSourceStore.unregisterHandler(type);
  };
}
